<template>
  <div class="container">
    <h1>Python Sending email example code</h1>
     <PythonGist />
  </div>
</template>
<script>
import PythonGist from './PythonGist'
export default {
  name: 'Python',
  components: {
    PythonGist
  }
}
</script>

<style scoped>
img{
  width: 90%;
}

</style>
